<template>
  <div class="card-detalhes-reclamacao-tecnica">
    <g-card
    :temCabecalho="false"
    :expansivel="false"
    >

      <div class="conteudo-card-detalhes-reclamacao-tecnica espacamento-pdf">
        <div class="titulo-grupo-detalhes"> Detalhes da Reclamação - {{DetalhesReclamacao.codigoReclamacao}} </div>
        <div class="grupo-dados-produto">
          <div class="dados-unidade">
            <div class="titulo-conteudo-detalhes"> Unidade </div>
            <div class="label-conteudo">{{DetalhesReclamacao.nomeEmpresa}}</div>
          </div>

          <div class="dados-codigo-cliente">
            <div class="titulo-conteudo-detalhes"> Código do Cliente </div>
            <div class="label-conteudo">{{DetalhesReclamacao.codigoCliente}}</div>
          </div>

          <div class="dados-cnpj">
            <div class="titulo-conteudo-detalhes"> CNPJ </div>
            <div class="label-conteudo">{{MascaraCnpj}}</div>
          </div>

          <div class="dados-razao-social">
            <div class="titulo-conteudo-detalhes"> Razão Social </div>
            <div class="label-conteudo">{{DetalhesReclamacao.razaoSocial}}</div>
          </div>

          <div class="dados-numero-pedido">
            <div class="titulo-conteudo-detalhes"> Nº Pedido </div>
            <div class="label-conteudo">{{DetalhesReclamacao.numeroPedido}}</div>
          </div>

          <div class="dados-numero-parcela">
            <div class="titulo-conteudo-detalhes"> Nº Parcela </div>
            <div class="label-conteudo">{{DetalhesReclamacao.numeroParcela}}</div>
          </div>

          <div class="dados-ordem-servico">
            <div class="titulo-conteudo-detalhes"> Ordem de Serviço </div>
            <div class="label-conteudo">{{DetalhesReclamacao.numeroOrdemServico}}</div>
          </div>

          <div class="dados-numero-notaFiscal">
            <div class="titulo-conteudo-detalhes"> Nota Fiscal </div>
            <div class="label-conteudo">{{DetalhesReclamacao.notaFiscal ? DetalhesReclamacao.notaFiscal : '--'}}</div>
          </div>

          <div class="dados-quantidade">
            <div class="titulo-conteudo-detalhes"> Quantidade com problema </div>
            <div class="label-conteudo">{{DetalhesReclamacao.quantidadeComProblema}}</div>
          </div>

          <div class="dados-nome-atendente">
            <div class="titulo-conteudo-detalhes"> Atendente </div>
            <div class="label-conteudo">{{DetalhesReclamacao.nomeAtendente ? DetalhesReclamacao.nomeAtendente : '--'}}</div>
          </div>

          <div class="dados-data-baixa">
            <div class="titulo-conteudo-detalhes"> Data da Baixa </div>
            <div class="label-conteudo">{{DetalhesReclamacao.dataDaBaixaFormatada}}</div>
          </div>
          
          <div class="dados-descricao-problema">
            <div class="titulo-conteudo-detalhes"> Descrição do problema (Mínimo: 10 caracteres) </div>                        
            <div class="label-conteudo">
              <PTextArea class="text-area-conteudo" v-model="DetalhesReclamacao.descricaoProblema" rows="4" cols="30" disabled></PTextArea>
            </div>
          </div>
          
          <div class="porcentagem-amostra">
            <div class="dados-porcentagem-concluida">
              <div class="titulo-conteudo-detalhes"> Progresso </div>
              <div class="porcentagem-concluida">
                <PProgressBar :value="DetalhesReclamacao.porcentagemConcluida"/>
              </div>
            </div>
            
            <div class="dados-acompanha-amostra">
              <div class="dados-checkbox">
                <div class="acompanha-amostra input-checkbox">
                  <PCheckBox id="acompanha-amostra" class="checkbox-consultas" :binary="true" :value="true" v-model="AcompanhaAmostra" disabled></PCheckBox>
                  <label class="acompanhaAmostra label-checkbox" for="acompanha-amostra"> Acompanha Amostra? </label>
                </div>
              </div>
            </div>
          </div>            
        </div>
      </div>
    </g-card>
  </div>
</template>

<script>
import ReclamacaoTecnicaComercialPDF from './ReclamacaoTecnicaComercialPDF.js' 
export default ReclamacaoTecnicaComercialPDF
</script>

<style scoped>
.grupo-dados-produto {
  display: grid;
  grid-template-columns: repeat(3, minmax(4em, 1fr));
  grid-template-rows: repeat(4, auto);
  grid-column-gap: 20px;
}

.dados-unidade { grid-area: 1 / 1 / 2 / 2; }
.dados-codigo-cliente { grid-area: 1 / 2 / 2 / 3; }
.dados-cnpj { grid-area: 1 / 3 / 2 / 4; }
.dados-razao-social { grid-area: 2 / 1 / 3 / 2; }
.dados-numero-pedido { grid-area: 2 / 2 / 3 / 3; }
.dados-numero-parcela { grid-area: 2 / 3 / 3 / 4; }
.dados-ordem-servico { grid-area: 3 / 1 / 4 / 2; }
.dados-numero-notaFiscal { grid-area: 3 / 2 / 4 / 3; }
.dados-quantidade { grid-area: 3 / 3 / 4 / 4; }
.dados-nome-atendente { grid-area: 4 / 1 / 5 / 2; }
.dados-data-baixa { grid-area: 4 / 2 / 5 / 3; }
.dados-descricao-problema { grid-area: 5 / 1 / 6 / 4; }
.porcentagem-amostra { grid-area: 6 / 1 / 7 / 3; }
:deep(.p-progressbar) {
  width: 100%;
}
.porcentagem-concluida {
  margin-top: 5px;
}

.porcentagem-amostra {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.text-area-conteudo {
  width: 100%;
  margin-top: 5px;
}

.cabecalho-detalhes {
  margin-bottom: 20px;
}

@media(min-width:310px) {}

@media(min-width:400px) {}

@media(min-width:500px) {}

@media(min-width:600px) {}

@media(min-width:801px) {}

@media(min-width:1025px) {}

@media(min-width:1285px) {}

@media(min-width:1500px) {}

@media(min-width:1600px) {}

@media(min-width:1800px) {}
</style>